import { useEffect, useState } from 'react';
import { Dialog, DialogTitle, DialogContent, DialogActions, Button, Table, TableHead, TableRow, TableCell, TableBody, TableContainer, Paper, TablePagination, Box } from '@mui/material';
import { toast } from 'react-toastify';
import { api } from '../helpers/apiRequest';
import colors from '../theme/Colors';


const UserDetailsDialog = ({ showUserModal, setShowUserModal, selectedUser }) => {
  const [customers, setCustomers] = useState([]);
  const [loading, setLoading] = useState(false);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(5);
  const [totalCustomers, setTotalCustomers] = useState(0);
  const [userInfo, setUser] = useState('');
  const fetchUser=async()=>{
    let user = await localStorage.getItem('user');
    user = JSON.parse(user);
    setUser(user);
  }
  useEffect(()=>{
    fetchUser();
  },[]);
  // Fetch customers if the user is a merchant
  useEffect(() => {
    if (selectedUser?.role === 'merchant') {
      fetchCustomers();
    }
  }, [selectedUser, page, rowsPerPage]);

  const fetchCustomers = async () => {
    try {
      setLoading(true);
      const queryParams = new URLSearchParams();
      queryParams.append('page', page + 1);
      queryParams.append('limit', rowsPerPage);

      const response = await api.get(`users/merchant/customers/${selectedUser._id}?${queryParams.toString()}`);
      console.log(response?.data?.data);
      setCustomers(response.data.data || []);
      setTotalCustomers(response.data.total || 0);
    } catch (error) {
      toast.error('Failed to load customers.');
      console.error(error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <Dialog open={showUserModal} onClose={() => setShowUserModal(false)} fullWidth maxWidth="md">
      <DialogTitle sx={{ textAlign: 'center', fontSize: 24, fontWeight: 'bold', pb: 0 }}>
        User Details
      </DialogTitle>
      
      <DialogContent sx={{ px: 4, py: 2 }}>
      {selectedUser ? (
            <Box
              sx={{
                display: 'flex',
                flexDirection: 'column',
                gap: 3,
                mt: 2,
              }}
            >
              {[
                { label: 'Name', value: selectedUser.name },
                { label: 'Email', value: selectedUser.email },
                { label: 'Phone 1', value: selectedUser.phone1 },
                { label: 'Phone 2', value: selectedUser.phone2 },
                { label: 'Phone 3', value: selectedUser.phone3 },
                userInfo?.role==='admin'&&{label:"Password",value:selectedUser?.actual_password},
                { label: 'Address', value: selectedUser.address },
                { label: 'City', value: selectedUser.city },
                { label: 'Country', value: selectedUser.country },
                { label: 'Company Name', value: selectedUser.company_name },
                { label: 'Fax', value: selectedUser.fax },
                { label: 'Remarks', value: selectedUser.remarks },
                { label: 'Balance', value: selectedUser.balance },
                { label: 'Role', value: selectedUser.role },
              ].map((field, index) => (
                <Box
                  key={index}
                  sx={{
                    display: 'flex',
                    justifyContent: 'space-between',
                    borderBottom: '1px solid #e0e0e0',
                    pb: 1,
                    fontSize: '1rem',
                    color: 'text.primary',
                  }}
                >
                  <strong>{field.label}:</strong>
                  <span>{field.value}</span>
                </Box>
              ))}
            </Box>
          ) : (
            <Box sx={{ textAlign: 'center', mt: 3, color: 'text.secondary' }}>
              No user selected.
            </Box>
          )}
        {selectedUser?.role === 'merchant'&&
            <DialogTitle sx={{ textAlign: 'center', fontSize: 20, fontWeight: 'bold', pb: 0 }}>
            Assigned Customers
          </DialogTitle>
        }
        {selectedUser?.role === 'merchant' ? (
          // Display customers in a table
          
          <Box>
            {loading ? (
              <p>Loading customers...</p>
            ) : customers.length > 0 ? (
              <TableContainer component={Paper}>
                <Table>
                  <TableHead >
                    <TableRow style={{backgroundColor:colors.primary}}>
                      <TableCell><strong>Name</strong></TableCell>
                      <TableCell><strong>Email</strong></TableCell>
                      <TableCell><strong>Phone</strong></TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {customers.map((customer) => (
                      <TableRow key={customer?.customer?._id}>
                        <TableCell>{customer?.customer?.name}</TableCell>
                        <TableCell>{customer?.customer?.email}</TableCell>
                        
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>
                <TablePagination
                  component="div"
                  count={totalCustomers}
                  page={page}
                  rowsPerPage={rowsPerPage}
                  onPageChange={(event, newPage) => setPage(newPage)}
                  onRowsPerPageChange={(event) => {
                    setRowsPerPage(parseInt(event.target.value, 10));
                    setPage(0);
                  }}
                />
              </TableContainer>
            ) : (
              <p>No customers assigned.</p>
            )}
          </Box>
        ) : (
          // Display normal user details
          <Box sx={{ display: 'flex', flexDirection: 'column', gap: 3, mt: 2 }}>
            {[
              { label: 'Name', value: selectedUser?.name },
              { label: 'Email', value: selectedUser?.email },
              { label: 'Phone 1', value: selectedUser?.phone1 },
              { label: 'Phone 2', value: selectedUser?.phone2 },
              { label: 'Phone 3', value: selectedUser?.phone3 },
              
              { label: 'Address', value: selectedUser?.address },
              { label: 'City', value: selectedUser?.city },
              { label: 'Country', value: selectedUser?.country },
              { label: 'Company Name', value: selectedUser?.company_name },
              { label: 'Fax', value: selectedUser?.fax },
              { label: 'Remarks', value: selectedUser?.remarks },
              { label: 'Balance', value: selectedUser?.balance },
              { label: 'Role', value: selectedUser?.role },
            ].map((field, index) => (
              <Box key={index} sx={{ display: 'flex', justifyContent: 'space-between', borderBottom: '1px solid #e0e0e0', pb: 1, fontSize: '1rem' }}>
                <strong>{field.label}:</strong>
                <span>{field.value}</span>
              </Box>
            ))}
          </Box>
        )}
      </DialogContent>
      <DialogActions sx={{ justifyContent: 'center', py: 2 }}>
        <Button
          onClick={() => setShowUserModal(false)}
          sx={{ backgroundColor:colors.primary, color: 'white', px: 4, borderRadius: '8px' }}
          variant="contained"
        >
          Close
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default UserDetailsDialog;
